// owned by WP-SHELL · English strings of the frame: banner, navigation, rail, status bar, search, route titles (shell-ia §20).
// Key path `econic.shell.*`; deep-merged by ./index.en.ts with every other area (a duplicate leaf key throws in development).
const shellEn = {
  econic: {
    shell: {
      /** Route titles (`RouteDef.title` in app/routes.tsx). */
      route: {
        login: "Sign in",
        password: "Change password",
        today: "ECONIC",
        agent: "ECONIC",
        myWorkspace: "My workspace",
        workspaces: "Desks",
        desk: "Desk",
        intelligence: "AI assistants",
        uaeRadar: "Economic Radar",
        uaeRadarIndicator: "Indicator",
        uaeRadarSector: "Sector",
        uaeRadarEmirate: "Emirate",
        globalRadar: "News Watch",
        globalRadarSignal: "Signal",
        outlook: "Economic Modelling",
        outlookScenario: "Scenario",
        outlookModel: "Model",
        country360: "Country360",
        country360Country: "Country",
        country360Brief: "Country brief",
        country360Engagement: "Engagement",
        country360Compare: "Compare countries",
        policylab: "Policy (PMO)",
        policylabFile: "Policy file",
        policylabLaw: "Law",
        policylabTemplate: "New from a template",
        policylabCommittee: "Committee",
        knowledge: "Knowledge Bank",
        knowledgeFiles: "Documents",
        knowledgePlatforms: "Ministry platforms",
        knowledgeWeb: "Public Web",
        knowledgeTheme: "Theme",
        knowledgeSearch: "Search results",
        knowledgePortal: "Portal",
        knowledgeDocument: "Document",
        knowledgeCompare: "Compare versions",
        knowledgeReviews: "Review queue",
        knowledgeManage: "Knowledge management console",
        knowledgeAdmin: "Librarian admin",
        knowledgeHow: "How the Knowledge Bank works",
        knowledgeStatistics: "Public Data",
        knowledgeUpload: "Add documents",
        report: "Report studio",
        tasks: "Tasks",
        trust: "Trust Centre",
        adminUsers: "Accounts",
        adminSessions: "Sessions",
        adminRollout: "Module rollout",
        adminAudit: "Audit log",
        settings: "Settings",
        chat: "Conversations",
        inbox: "Inbox",
        matters: "Files",
        matter: "File",
        decision: "Decision brief",
        artifacts: "Drafts and reports",
        myPages: "My pages",
        myPage: "My page",
        evidence: "Evidence explorer",
        library: "Library",
        tracker: "Portfolio tracker",
        notFound: "Address not found",
      },
      /** The wave-0 screen stub (econic/lib/stub.tsx); removed once no screen uses it. */
      stub: {
        eyebrow: "ECONIC · being built",
        body: "This screen is part of the ECONIC build and opens here once it is ready. Until then it shows no figures.",
        goToday: "Go to ECONIC",
        goWorkspaces: "Open the desks",
      },
      error: {
        notFound: "This address is not part of ECONIC",
        notFoundBody: "The address may be mistyped, or the screen may have moved. The navigation leads to every part of ECONIC.",
        address: "Address: {{path}}",
        goToday: "Go to ECONIC",
        search: "Search ECONIC instead",
        screen: "This screen could not load",
        screenBody: "The rest of ECONIC keeps working. Trying again usually helps; if it does not, report the reference below.",
        reference: "Reference",
        retry: "Try again",
        reload: "Reload ECONIC",
        reloadBody: "A required part of ECONIC could not load. Check your connection, then reload when you are ready. Copy any unsent text first.",
        forbiddenTitle: "Not included in your account",
        forbidden: "Your account does not include {{what}}. Contact your administrator for access.",
        forbiddenHint: "Access follows your role and department; this page sends no request on your behalf.",
      },
      forbidden: {
        econic: "ECONIC",
        knowledge: "the Knowledge Bank",
        knowledgeManage: "the knowledge management console",
        intelligence: "the AI assistants",
        country360: "Country360",
        outlook: "Economic Modelling",
        policylab: "Policy (PMO)",
        desks: "the process desks",
        tasks: "Tasks and routines",
        files: "studies and files",
        trust: "the Trust Centre",
        accounts: "account administration",
        audit: "the audit log",
        rollout: "module rollout",
        screen: "this screen",
        permission: "Permission",
      },
      settings: {
        title: "Settings",
        subtitle: "Your choices follow you to every browser you sign in on.",
        sections: "Settings sections",
        section: { appearance: "Appearance", language: "Language", accessibility: "Accessibility", notifications: "Notifications", security: "Sign-in and sessions", memory: "What ECONIC remembers" },
        appearanceHint: "How ECONIC looks for you; nobody else's screen changes.",
        themeHint: "Dark is ECONIC Night: the same skyline after sunset.",
        density: "Density",
        densityHint: "Compact fits more rows on a screen; comfortable gives them more room.",
        comfortable: "Comfortable",
        compact: "Compact",
        sceneHint: "The photograph behind the glass; it never covers figures or text.",
        languageHint: "The language of every screen, PDF draft and the AI assistant's answers.",
        languageNote: "Arabic is written natively for ECONIC; the wording is pending MoET review.",
        a11yHint: "These apply to the frame, the modules and the process desks.",
        notifyHint: "How routine results, deadlines and decisions reach you.",
        digest: "Delivery",
        digestHint: "Instant sends each item as it happens; daily gathers them into one message at 07:00 GST.",
        instant: "Instant",
        daily: "Daily digest",
        quiet: "Quiet hours",
        quietHint: "Nothing is sent in this window, except sign-in and security messages.",
        quietFrom: "Quiet from",
        quietTo: "Quiet until",
        sessions: "Active sessions",
        sessionsHint: "Every browser where your account is signed in. Signing a session out ends it at once.",
        noSessions: "This sign-in is a development session; sessions are listed once the strict sign-in is in force.",
        sessionsFailed: "The session list could not be read just now.",
        thisSession: "This session",
        since: "Signed in {{when}}",
        lastActive: "last active {{when}}",
        revoke: "Sign out",
        revoked: "That session was signed out",
        revokeFailed: "That session could not be signed out",
        passwordHint: "Your administrator cannot see your password.",
        passwordHintMfa: "Your administrator cannot see your password or your authenticator secret.",
        passwordUnavailable: "Changing the password needs the strict sign-in; it is not available in this development session.",
        currentPassword: "Current password",
        newPassword: "New password",
        passwordRules: "At least 14 characters; not one of your last five; not found in known breaches.",
        code: "Authenticator code",
        changePassword: "Change password",
        passwordChanged: "Password changed. Your other sessions were signed out.",
        passwordPolicy: "The new password does not meet the rules above.",
        passwordLimited: "Too many attempts. Try again in a minute.",
        passwordFailed: "The password was not changed. Check the current password.",
        passwordFailedMfa: "The password was not changed. Check the current password and the code.",
      },
      brand: {
        agentWithin: "AI assistant within ECONIC",
        home: "{{ministry}} — ECONIC home",
      },
      env: { qa: "QA environment", dev: "Development" },
      /** The classification banner (DESIGN-SYSTEM §10.1). */
      class: {
        label: "Classification",
        highest: "Highest marking on this screen: {{level}}. {{source}}",
        highestShort: "Highest marking on this screen",
        popTitle: "This screen is marked {{level}}",
        floor: "Every signed-in screen is at least Internal",
        floorOf: "{{screen}} · screen floor",
        policy: "How each marking is handled",
        trust: "Encrypted · Audited",
        trustLink: "Encrypted and audited: open the Trust Centre",
        whLink: "{{text}} · open the Trust Centre",
        handling: {
          public: "Cleared for release once approved. Still handled inside the Ministry until it is published.",
          internal: "For Ministry use only. External AI models may process it under their providers' terms; Restricted content is never sent to them.",
          internalZdr: "For Ministry use only. External AI models are used only on zero-retention routes.",
          internalOffline: "For Ministry use only. This system calls no external AI model.",
          restricted: "Named teams only. Restricted content is never sent to an external AI: the assistant sees titles only.",
          confidential: "No AI processing. Confidential documents are not stored in ECONIC.",
        },
        withheld: {
          public: "Cleared for release once approved",
          internal: "Restricted content is never sent to external models",
          internalZdr: "External models only on zero-retention routes",
          internalOffline: "No external AI models on this system",
          restricted: "Never sent to an external AI · titles only",
          confidential: "No AI processing",
        },
      },
      /** The top navigation (DESIGN-SYSTEM §10.2; 16 Oct 2026): ECONIC · AI assistants ⌄ · My workspace. No counts or dots. */
      nav: {
        primary: "Primary",
        destinations: "Destinations",
        econic: "ECONIC",
        agents: "AI assistants",
        myWorkspace: "My workspace",
        knowledge: "Knowledge Bank",
        trust: "Trust Centre",
        accounts: "Accounts",
        audit: "Audit log",
        econicTab: "ECONIC",
        agentsTab: "AI assistants",
        myWorkspaceTab: "My workspace",
        moreTab: "More",
      },
      module: {
        status: {
          live: "Live · {{time}}",
          liveNoTime: "Live",
          stale: "Needs refresh",
          awaiting: "Awaiting MoET input",
          unknown: "Status unavailable",
        },
        badge: { foundation: "Foundation", priority: "Priority module" },
        purpose: {
          kb: "Institutional knowledge and AI search",
          "uae-radar": "Domestic indicators, sectors and emirates",
          "global-radar": "World news and signals that matter to the UAE",
          outlook: "Projections, nowcast and scenarios",
          country360: "Screening the UAE's bilateral economic activity",
          policylab: "The policy AI assistant supplied by the Prime Minister's Office",
        },
      },
      /** The AI assistants menu of the toolbar (16 Oct 2026; "AI assistants" since 29 Oct 2026, PMO guidance): "All AI assistants", then each assistant's name and one-line purpose. */
      intel: {
        heading: "All AI assistants",
        noAccess: "{{module}} is not included in your account",
        desc: {
          kb: "Institutional memory",
          "uae-radar": "Domestic indicators",
          country360: "Bilateral economic relations",
          policylab: "Supplied by the PMO · policy drafting",
          outlook: "Nowcasts and scenarios",
          "global-radar": "News and signals for the UAE",
        },
      },
      /** The status bar (DESIGN-SYSTEM §10.4). */
      status: {
        label: "Session status",
        secure: "Secure session · password + authenticator",
        password: "Secure session · password",
        devSession: "Development sign-in · not strict",
        https: "encrypted connection",
        local: "local connection",
        idle: "Idle sign-out in",
        lastSignIn: "Last sign-in {{when}}",
        series: "{{n}} series",
        liveCheck: "live check {{time}}",
        audited: "Every action is audited",
        stay: "Stay signed in",
        help: "Help",
        accessibility: "Accessibility",
      },
      session: {
        lastSignIn: "Last sign-in {{when}} · {{device}}",
        deviceUnknown: "device not recorded",
        firstSignIn: "First sign-in on this account",
        others: "Other active sessions: {{count}}",
      },
      header: { crumbs: "You are here", exportPdf: "Export PDF", ask: "Ask about this screen" },
      /** The agent column (DESIGN-SYSTEM §10.15; the conversation itself is WP-SIDEBAR's). */
      sidebar: {
        title: "ECONIC",
        railLabel: "ECONIC (collapsed)",
        open: "Open the assistant",
        new: "New conversation",
        history: "Conversations",
        expand: "Expand the assistant",
        resize: "Resize the assistant",
        fullScreen: "Full screen",
        rail: "Collapse to rail",
        asYou: "As you",
        asYouShort: "as you",
        asYouHint: "The AI assistant works with your access, nothing more",
        offline: "AI unavailable · data still live",
        note: "Drafts and options only — a person accepts every output",
        askPlaceholder: "Ask ECONIC…",
      },
      dept: {
        label: "Department",
        switch: "Switch department",
        switchCurrent: "Department: {{dept}}. Switch department",
        find: "Find a unit",
        yours: "Your departments",
        none: "No live department matches",
        notMember: "Not a member",
        current: "Current department",
        sector: "Part of the {{sector}}",
        others: "Other ministry units",
        onboarding: "Onboarding · wave 2",
        otherWorkspaces: "Other workspaces",
        partial: "This list shows your own departments; the other ministry units appear once the department service is available.",
        now: "Now in {{dept}}",
        deskElsewhere: "{{desk}} belongs to {{dept}}",
        openWorkspaces: "Open the desks",
      },
      /** The Inbox bell (shell-ia §8). */
      inbox: {
        title: "Inbox",
        label: "Notifications",
        badge_zero: "Notifications: nothing needs your decision",
        badge_one: "Notifications: {{mine}} needs your decision",
        badge_two: "Notifications: {{mine}} need your decision",
        badge_few: "Notifications: {{mine}} need your decision",
        badge_many: "Notifications: {{mine}} need your decision",
        badge_other: "Notifications: {{mine}} need your decision",
        badgeUnread: "Notifications: {{count}} unread",
        scope: "Inbox scope",
        forMe: "For me",
        department: "Department",
        deptInInbox: "Department items in the full inbox: {{count}}",
        footDept: "Department: {{department}}",
        footTop: "Showing {{shown}} of {{total}}",
        split: "{{mine}} mine · {{department}} department",
        decisions: "Decisions",
        waiting: "Waiting on you",
        notifications: "Notifications",
        inFullInbox: "Decisions and waiting steps are listed in the full inbox.",
        empty: "Nothing needs you right now",
        unread: "Unread",
        review: "Review",
        openRow: "Open",
        open: "Open inbox",
        readAll: "Mark all as read",
      },
      trust: { open: "Trust Centre", good: "Trust Centre · all controls in place", warn: "Trust Centre · a control needs attention" },
      /** ♿ Accessibility and appearance (shell-ia §9.1). */
      a11y: {
        open: "Accessibility, text size and contrast",
        title: "Accessibility",
        textSize: "Text size",
        standard: "Standard",
        large: "Large",
        larger: "Larger",
        contrast: "Higher contrast",
        contrastHint: "Solid surfaces and stronger outlines; the scene is dimmed",
        motion: "Reduce motion",
        transparency: "Reduce transparency",
        followDevice: "Follow device",
        reduce: "Reduce",
        allow: "Allow",
        statement: "Accessibility statement",
      },
      theme: { title: "Theme", light: "Light", dark: "Dark", auto: "Automatic", scene: "Scene behind the glass" },
      look: { title: "Look", classic: "Classic", signature: "Signature", aurora: "Aurora", hint: "How ECONIC looks for you. Light and dark still follow Appearance." },
      faces: { title: "AI assistants", auto: "Automatic", icon: "Icon", emblem: "Emblem", hint: "How the AI assistants look for you: their icon or their emblem. Automatic follows the look." },
      lang: { other: "العربية", switch: "Switch to Arabic" },
      account: {
        menu: "Account menu: {{name}}",
        title: "Account",
        noClearance: "No content clearance · platform administration only",
        cleared: "Cleared to {{level}}",
        secure: "Secure session",
        secureHow: "password + authenticator",
        secureHowPassword: "password",
        secureHowSso: "Ministry SSO",
        lastSignIn: "last sign-in {{when}}",
        language: "Language",
        settings: "Settings",
        appearance: "Appearance",
        sessions: "My sessions",
        security: "Sign-in and security",
        display: "Accessibility and display…",
        trustGood: "All controls in place",
        trustWarn: "Needs attention",
        password: "Change password",
        shortcuts: "Keyboard shortcuts",
        about: "Help & About ECONIC",
        report: "Report an issue",
        console: "Admin console",
        signOut: "Sign out",
      },
      /** Help & About ECONIC (ECN-003, ECN-004). */
      about: {
        isTitle: "What ECONIC is",
        is: {
          tool: { title: "An internal intelligence tool.", body: "Built for the Ministry's own analysts, directors and leadership.", link: "Knowledge Bank" },
          layer: { title: "A shared evidence and knowledge layer.", body: "One governed store of the Ministry's documents, data and sources, searchable in English and Arabic.", link: "Search" },
          connector: { title: "A connector across departments.", body: "Five ECONIC AI assistants give every department the same figures; Policy (PMO) is supplied by the PMO.", link: "AI assistants" },
          enabler: { title: "An enabler of faster analysis and stronger briefs.", body: "Cited drafts, figure checks and PDFs a person reviews before they go anywhere.", link: "ECONIC" },
        },
        notTitle: "What ECONIC is not",
        not: {
          agentification: { title: "Not the automation of processes by AI.", body: "The desks follow the Ministry's own procedures; AI assistants draft, people decide." },
          public: { title: "Not a public-facing services platform.", body: "There is no public route; every screen needs a Ministry account." },
          ownership: { title: "Not a replacement for departmental ownership.", body: "Each department owns its content, reviews and approvals." },
          autonomous: { title: "Not an autonomous decision-maker.", body: "AI support is labelled options for consideration and needs a person's acceptance." },
        },
        decide: "Drafts and options only — a person accepts every output.",
        version: "ECONIC {{version}}",
      },
      /** ⌘K search (shell-ia §6). */
      search: {
        button: "Search",
        open: "Search ECONIC",
        placeholder: "Search ECONIC: documents, indicators, countries, desks, chats, people",
        close: "Close search",
        scopes: "Search scope",
        scope: { all: "All", kb: "Knowledge Bank", intelligence: "AI assistants", desks: "Desks", chats: "Chats", files: "Files", people: "People" },
        group: {
          recent: "Recent",
          go: "Go to",
          actions: "Actions",
          modules: "AI assistants",
          countries: "Countries",
          desks: "Desks",
          kb: "Knowledge Bank",
          indicators: "Indicators",
          chats: "Conversations",
          files: "Studies & files",
          people: "People",
          suggested: "Suggested",
          ask: "Ask ECONIC",
          top: "Top hit",
          figures: "Figures",
          docs: "Documents and pages",
        },
        askAbout: "Tell me about {{title}}",
        restricted: "Restricted",
        empty: "Nothing found for “{{q}}”. Search covers only what your account may open.",
        partial: "Some sources took too long and are not shown",
        hint: "Enter to open · ⇧Enter to ask ECONIC · Tab to change scope",
        clearRecent: "Clear recent",
        all: "See all results for “{{q}}”",
        kind: { route: "Screen", desk: "Desk", module: "AI assistant", action: "Action", kb: "Knowledge Bank", file: "Study or file", person: "Person", chat: "Conversation", country: "Country", indicator: "Indicator", ask: "Ask ECONIC" },
        level: { public: "Public", internal: "Internal", restricted: "Restricted", confidential: "Confidential" },
        askSub: "Answers cite their sources and stay within your access",
        askAgentPrefix: "Ask ECONIC:",
        askAgentEmpty: "Ask ECONIC…",
        askAgentSub: "Opens a conversation with your question and this screen",
        askWhy: "What should I know about {{q}}?",
        official: "official",
        updated: "updated {{date}}",
        editLayout: "Edit this screen's layout",
        results: "Search results",
        keys: { move: "to move", open: "to open", ask: "to ask ECONIC" },
        everything: "Search everything",
        clear: "Clear search",
        cancel: "Cancel",
      },
      skip: { content: "Skip to content", agent: "Skip to the AI assistant" },
      drop: {
        kb: "Drop to add to the Knowledge Bank",
        kbHint: "The files go to review before anyone else sees them",
        chat: "Drop to attach to the conversation",
        chatUnavailable: "Attaching files to this conversation is not available here yet; the Knowledge Bank takes them from any other part of the screen.",
        kbUnavailable: "The Knowledge Bank upload is not available on this server yet; nothing was sent.",
      },
      /** My workspace (`/my-workspace`, 16 Oct 2026): the person's own board, conversations, the department's desks, files and pages. */
      myWorkspace: {
        title: "My workspace",
        private: "Only you see it",
        conversations: "Recent conversations",
        conversationsEmpty: "Your conversations with ECONIC appear here.",
        conversationsFailed: "Your conversations could not be read just now.",
        untitled: "Untitled conversation",
        more: "Show more",
        less: "Show less",
        work: "Files and pages",
        myPagesSub: "Pages you made or saved",
        mattersSub: "Studies and files you work on",
        artifactsSub: "Drafts and reports from your conversations",
      },
      shortcuts: {
        search: "Search ECONIC",
        agent: "Open or collapse the assistant",
        askResult: "Ask the AI assistant about a search result",
        escape: "Close the topmost panel",
        hint: "Single keys work anywhere outside a text field.",
      },
    },
  },
};

export default shellEn;
